import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type UiModalChangeListItem = {
  label: string;
  previous: string;
  current: string;
};

@Component({
  selector: 'lib-ui-modal-change-list',
  templateUrl: './ui-modal-change-list.component.html',
  styleUrl: './ui-modal-change-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiModalChangeListComponent {
   readonly items = input<UiModalChangeListItem[]>([]);
  readonly previousLabel = input<string>('Antes');
  readonly currentLabel = input<string>('Depois');
}
